var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));

// src/DataLayer.ts
var DataLayer = class _DataLayer {
  constructor() {
    this.triggerListener = (target) => {
      const props = this.createPropsFromAttributes(
        target.attributes
      );
      if (props.event) {
        this.pushEvent(props.event, props);
      }
    };
    window.dataLayer = window.dataLayer || [];
    this.eventProps = /* @__PURE__ */ new Map();
    this.eventValidators = /* @__PURE__ */ new Map();
    this.eventTriggers = new Set(
      ...[document.querySelectorAll("[data-tracking='trigger']")]
    );
    if (this.eventTriggers.size) {
      this.setTriggerListeners();
    }
    this.setListener();
  }
  static getInstance() {
    if (!_DataLayer.instance) {
      _DataLayer.instance = new _DataLayer();
    }
    return _DataLayer.instance;
  }
  setTriggerListeners() {
    [...this.eventTriggers].map(
      (trigger) => trigger.addEventListener("click", () => this.triggerListener(trigger))
    );
  }
  setListener() {
    window.addEventListener("click", (ev) => {
      const eventTarget = ev.target;
      const target = eventTarget.closest("[data-tracking-event]");
      if (target) {
        this.triggerListener(target);
      }
    });
  }
  setEventDefaultProps(event, props) {
    this.eventProps.set(event, props);
  }
  setEventValidator(event, callback) {
    this.eventValidators.set(event, callback);
  }
  pushEvent(event, props) {
    if (this.eventValidators.has(event)) {
      if (this.eventValidators.get(event)(props) === true) {
        this.sendEvent(event, props);
      } else {
        console.warn(`DataLayer: Event "${event}" wasn't validated`);
      }
    } else {
      this.sendEvent(event, props);
    }
  }
  sendEvent(event, props) {
    window.dataLayer.push(__spreadValues(__spreadValues({
      event
    }, props), this.eventProps.get(event)));
  }
  createPropsFromAttributes(attributes) {
    return [...attributes].filter((attr) => /^data-tracking-/g.test(attr.name)).reduce(
      (acc, attr) => __spreadProps(__spreadValues({}, acc), {
        [this.formatPropName(attr.name)]: attr.value
      }),
      {}
    );
  }
  formatPropName(propName, format = "camel") {
    const propNameArray = propName.replace("data-tracking-", "").split("-");
    const propNames = {
      snake: propNameArray.join("_"),
      camel: propNameArray.map(
        (word, index) => index === 0 ? word : word.charAt(0).toUpperCase() + word.slice(1)
      ).join("")
    };
    return propNames[format];
  }
};

// src/index.ts
var DataLayer2 = DataLayer.getInstance();
export {
  DataLayer2 as DataLayer
};
